import { faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { faMobileScreen } from "@fortawesome/free-solid-svg-icons";
import ToggleUI from "../atoms/ToggleUI";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { t, use } from "i18next";
import { FC } from "react";
import { Avatar } from "../atoms/Avatar";
import { ButtonSoft } from "../atoms/ButtonSoft";
import { MultiSelectAction } from "./MultiSelectAction";
import { ToggleText } from "./ToggleText";
import { ButtonSecondary } from "../atoms/ButtonSecondary";

type UserProps = {
  id: string;
  name: string;
  email: string;
  phone: string;
  email_verified_at: string;
  email_verified_command: string;
  password: string;
  remember_token: string;
  admin: string;
  role: string;
  status: string;
  app: string;
  account_stripe_id: string;
  account_payment_method_id: string;
  expires_date: string;
  ankle_dorsiflexion_left: string;
  ankle_dorsiflexion_right: string;
  last_visited: string;
  frecuency: string;
  company: string;
  occupation: string;
  occupation_description: string;
  category: string;
  other: string;
  comments: string;
  deltoid_ailments: string;
  cervical_ailments: string;
  lumbar_ailments: string;
  hip_ailments: string;
  knee_ailments: string;
  ankle_ailments: string;
  cardiorespiratory: string;
  strength: string;
  thoracic_mobility: string;
  squat: string;
  self_charging: string;
  leg: string;
  is_subscriber: string;
  branch_id: string;
  external_id: string;
  external_id_json: string;
  external_source: string;
  communication: string;
  avatar: string;
  is_chat_responsible: string;
  accumulated: string;
  created_at: string;
  updated_at: string;
  stripe_id: string;
  card_brand: string;
  card_last_four: string;
  trial_ends_at: string;
  is_email_updating: string;
  objective: string;
  has_pending_registration: string;
  active: string;
  meet_link: string;
  facebook_token: string;
  sign_path: string;
  hand_ailments: string;
  elbow_ailments: string;
  file_nutrition: string;
  tag_merketing: string;
  tag_users: string;
  notification_token: string;
  all_lessons: string;
  inactive_last_date: string;
  active_last_date: string;
  notes: string;
  stages: string;
  user_active: string;
  user_id: string;
  sex: string;
  birthday: string;
  comment: string;
  campaign: string;
};

type UserRestanteProps = {
  createAt: string;
  birthday: string;
  sex: string;
};

type option = {
  id: string | number;
  name: string;
};

type InformationPanelUserProps = {
  user: UserProps;
  userRestante: UserRestanteProps;
  optionsUserTags: option[];
  selectedOptionsUserTags: option[];
  setSelectedOptionsUserTags: (value: option[]) => void;
  userTagsSave: option[];
  marketingTagsSave: option[];
  setDeselectedOptionsUserTags: (value: option[]) => void;
  setDeselectedOptionsMarketingTags: (value: option[]) => void;
  optionMarketingTags: option[];
  selectedOptionMarketingTags: option[];
  setSelectedOptionMarketingTags: (value: option[]) => void;
  onMethodsPay?: () => void;
  onRevenueUsers?: () => void;
  ToggleStatus: boolean;
  setToggleStatus: (id: number, state: boolean) => void;
  handleEdit: () => void;
  handleFirma: () => void;
  handleRestPass: () => void;
  handleWebApp: () => void;
  handleDelet: () => void;
  noFirma?: boolean;
  noPeopleTags?: boolean;
};

/* 
{
    "id": 22,
    "name": "Prueba",
    "email": "Snd",
    "sex": "Hombre",
    "phone": "27473",
    "birthday": "2023-12-14",
    "comment": null,
    "campaign": 1,
    "created_at": "2023-12-04T21:03:45.000000Z",
    "updated_at": "2023-12-04T21:03:45.000000Z",
    "campaign_id": 7,
    "media": null,
    "user_id": null,
    "branch_id": 202,
    "stages": "interested",
    "notes": null,
    "user_active": 0,
    "tag_merketing": null,
    "tag_users": null
}

*/

export const InformationPanelUser: FC<InformationPanelUserProps> = ({
  user,
  userRestante,
  optionsUserTags,
  selectedOptionsUserTags,
  setSelectedOptionsUserTags,
  setDeselectedOptionsUserTags,
  setDeselectedOptionsMarketingTags,
  userTagsSave,
  marketingTagsSave,
  optionMarketingTags,
  selectedOptionMarketingTags,
  setSelectedOptionMarketingTags,
  onMethodsPay,
  onRevenueUsers,
  ToggleStatus,
  setToggleStatus,
  handleEdit,
  handleFirma,
  handleRestPass,
  handleWebApp,
  handleDelet,
  noactive = false,
  noFirma = true,
  noPeopleTags = true,
}) => {
  return (
    <>
      <div className="rounded-lg bg-gray-50 shadow-sm ring-1 ring-gray-900/5">
        <div className="flex flex-wrap border-b border-gray-900/5">
          <div className="flex-auto pl-4 pt-6 pb-6 flex items-center space-x-4">
            <Avatar src={user.avatar} size="extraLarge" />
            <p className=" lg:whitespace-normal lg:flex-grow lg:flex-shrink-0">
              {user.name}
              <br />
              {!noactive && (
                <div className="mt-2 pr-3">
                  <ToggleText
                    checked={ToggleStatus === 1} // Si es 1, será true; si es cualquier otro valor, será false
                    onChange={(state) => setToggleStatus(user.id, state)}
                    texto={
                      ToggleStatus === 1
                        ? t("bond.views.active")
                        : t("bond.views.inactive")
                    }
                  />
                </div>
              )}
            </p>
          </div>
        </div>

        <div className="flex flex-wrap">
          <div className="w-full">
            {/* Información General */}
            <div className="mt-6 mx-2">
              <div className="space-y-12">
                <div className="grid grid-cols-1 gap-x-2 md:grid-cols-2 border-b border-gray-900/5 pb-6">
                  <div className="flex items-center h-full text-center ">
                    <div>
                      <h2 className="text-base font-semibold leading-7 text-gray-900 mt-5 mb-5 lg:pl-5 text-center md:mt-0 md:mb-0">
                        {user?.role === "Coach"
                          ? t("user.views.coach")
                          : user?.role === "Manager"
                            ? t("user.views.manager")
                            : user?.role === "Client"
                              ? t("user.views.user")
                              : user?.role}
                      </h2>
                    </div>
                  </div>
                  <div className="lg:-ml-10 xl:-ml-20 grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-6 lg:pl-5">
                    <div className="col-span-full">
                      <div className="flex justify-between">
                        <label
                          htmlFor=""
                          className="block text-sm font-medium leading-6 text-gray-600"
                        >
                          {t("chat.app.email")}
                        </label>
                      </div>
                      <p className="relative break-words overflow-hidden pr-7">
                        {user.email}
                      </p>
                    </div>

                    <div className="col-span-full">
                      <div className="flex justify-between">
                        <label
                          htmlFor=""
                          className="block text-sm font-medium leading-6 text-gray-600"
                        >
                          {t("user.views.phone")}
                        </label>
                      </div>
                      <p className="relative break-words overflow-hidden">
                        <a
                          href={`https://api.whatsapp.com/send/?phone=${user.phone}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {user.phone}
                        </a>
                      </p>
                    </div>

                    <div className="col-span-full">
                      <div className="flex justify-between">
                        <label
                          htmlFor=""
                          className="block text-sm font-medium leading-6 text-gray-600"
                        >
                          {t("user.views.registrado")}
                        </label>
                      </div>

                      <p className="relative break-words overflow-hidden">
                        {userRestante?.createAt ||
                          user?.created_at && new Date(user?.created_at).toLocaleDateString()}
                      </p>
                    </div>

                    <div className="col-span-full">
                      <div className="flex justify-between">
                        <label
                          htmlFor=""
                          className="block text-sm font-medium leading-6 text-gray-600"
                        >
                          {t("user.views.birthday")}
                        </label>
                      </div>

                      <p className="relative break-words overflow-hidden">
                        {userRestante?.birthday || user?.birthday}
                      </p>
                    </div>

                    <div className="col-span-full">
                      <div className="flex justify-between">
                        <label
                          htmlFor=""
                          className="block text-sm font-medium leading-6 text-gray-600"
                        >
                          {t("user.views.sex")}
                        </label>
                      </div>

                      <p className="relative break-words overflow-hidden">
                        {userRestante?.sex || user?.sex}
                      </p>
                    </div>

                    <div className="col-span-full">
                      <div className="flex justify-between">
                        <label
                          htmlFor=""
                          className="block text-sm font-medium leading-6 text-gray-600"
                        >
                          {user?.stages ? "Etapa" : t("user.views.objective")}
                        </label>
                      </div>

                      <p className="relative break-words overflow-hidden pr-7">
                        {user.objective || user?.stages}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-1 gap-x-2 md:grid-cols-2 border-b border-gray-900/5 pb-6">
                  <div className="flex items-center h-full text-center ">
                    <div>
                      <h2 className="text-base font-semibold leading-7 text-gray-900 mt-5 mb-5 lg:pl-5 text-center md:mt-0 md:mb-0">
                        {t("brand.views.tags")}
                      </h2>
                    </div>
                  </div>
                  <div className="md:-ml-5 lg:-ml-10 xl:-ml-20 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-1">
                    <div className=" col-span-full pr-4">
                      {!noPeopleTags && (
                        <MultiSelectAction
                          title={t("brand.views.user")}
                          options={optionsUserTags}
                          selectedOptions={selectedOptionsUserTags}
                          setSelectedOptions={setSelectedOptionsUserTags}
                          setSelectedOptionsSave={setDeselectedOptionsUserTags}
                          selectedOptionsSave={userTagsSave}
                        />
                      )}
                    </div>
                    <div className="col-span-full pr-4">
                      <MultiSelectAction
                        title={t("brand.views.title")}
                        options={optionMarketingTags}
                        selectedOptions={selectedOptionMarketingTags}
                        setSelectedOptions={setSelectedOptionMarketingTags}
                        setSelectedOptionsSave={
                          setDeselectedOptionsMarketingTags
                        }
                        selectedOptionsSave={marketingTagsSave}
                      />
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-1 gap-x-2 md:grid-cols-2">
                  {!noPeopleTags && (
                    <div className="flex items-center h-full text-center ">
                      <div>
                        <h2 className="text-base font-semibold leading-7 text-gray-900 mt-5 mb-5 lg:pl-5 text-center md:mt-0 md:mb-0">
                          {t("accounting.views.incomes")}
                        </h2>
                      </div>
                    </div>
                  )}

                  {!noPeopleTags &&
                    (user?.branch?.customer_to_gym_subscription ||
                      user?.branch?.lesson_module ||
                      user?.branch?.assisted_module ||
                      user?.branch?.slots ||
                      user?.branch?.store) && (
                      <div className="md:-ml-5 lg:-ml-10 xl:-ml-20 grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-6 md:col-span-1">
                        {!noPeopleTags && (
                          <>
                            <div className="col-span-full pr-4">
                              <a
                                onClick={onMethodsPay}
                                href="#"
                                className="text-primary-600 hover:text-primary-900 ml-4 mr-4"
                              >
                                {t("accounting.views.payment_method")}
                              </a>
                            </div>
                            <div className="col-span-full pr-4">
                              <a
                                onClick={onRevenueUsers}
                                href="#"
                                className="text-primary-600 hover:text-primary-900 ml-4 mr-4"
                              >
                                {!noPeopleTags && t("user.views.revenue")}
                              </a>
                            </div>
                          </>
                        )}
                      </div>
                    )}
                </div>
                {!noFirma && (
                  <div className="grid grid-cols-1 ">
                    <div className="flex w-full px-2">
                      {!user?.branch?.contract_url && (
                        <ButtonSecondary
                          size="extraLarge"
                          text={user?.signPath ? "Firmado" : "Firmar"}
                          onClick={handleFirma}
                        />
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-wrap border-t border-gray-900/5 mt-6">
          <div className="flex-auto pl-4 pt-6 pb-6">
            {user?.role === "Client" && (
              <ButtonSoft
                onClick={handleRestPass}
                size="large"
                text={t("user.views.reset_password")}
              />
            )}
            <a
              onClick={handleEdit}
              href="#"
              className="text-primary-600 text-sm hover:text-primary-900 ml-4 mr-4"
            >
              {t("general.edit")}
            </a>
            <button
              type="button"
              onClick={handleDelet}
              className="text-red-600 hover:text-red-900 mr-4"
            >
              <FontAwesomeIcon icon={faTrashCan} />
            </button>
            {user?.role === "Super Admin" && (
              <button
                type="button"
                onClick={handleWebApp}
                className="text-gray-600 hover:text-gray-900 mr-4"
              >
                <FontAwesomeIcon icon={faMobileScreen} />
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
